import React from 'react';
import ShowMainTransactionDataFormView from './ShowMainTransactionDataFormView';
import { useAppContext } from '../context/AppContext';
import { ViewStateEnum } from '../context/viewStateEnum';
import FormIntro from './FormIntro';

type Props = {
  handleSubmit: () => void;
  formLocks: boolean;
};

const Form = ({ handleSubmit }: Props) => {
  const { viewState } = useAppContext();

  return (
    <>
      {viewState.state === ViewStateEnum.FILL_MAIN_TRANSACTION_DATA && (
        <>
          <FormIntro message="formIntroFirstStep.titleLine" />
          <FormIntro message="formIntroFirstStep.space" />
          <ShowMainTransactionDataFormView onSubmit={handleSubmit} />
        </>
      )}
    </>
  );
};

export default Form;
